<div class="custom-switch-pill flex-start-center" [tooltipPosition]="tooltipPosition" [pTooltip]="tooltipText">
  <p *ngIf="position === 'start'" [class]="styleClassLabel"
    [ngClass]="{'field-side-label cursor-default mb-0 mr-2': true}" [ngStyle]="{fontSize: fontSize + 'px'}">
    {{label}}
  </p>
  <input type="text" class="hidden-input" [disabled]="disabled" id="{{id}}h" (focus)="checkboxEl.focus()"
    (keydown.enter)="onChange({target: {checked: !isActive}})"
    (keydown.space)="onChange({target: {checked: !isActive}})">
  <label class="switch switch-pill switch-success">
    <input type="checkbox" class="switch-input" [attr.data-checked]="isActive" [id]="id" [name]="id"
      [(ngModel)]="isActive" (change)="onChange($event)" [disabled]="disabled" #checkboxEl>
    <span class="switch-slider"
    [attr.id]="pxId"
    ></span>
  </label>
  <p *ngIf="position === 'end'" [class]="styleClassLabel"
    [ngClass]="{'field-side-label cursor-default mb-0 ml-2': true}" [ngStyle]="{fontSize: fontSize + 'px'}">
    {{label}}
  </p>
</div>